module.exports = __webpack_public_path__ + "static/media/trash.cc6d8121.svg";